import React from 'react';
import './ProductList.css';

const ProductList = (props) => {
    return (
        <div>
            ProductList
        </div>
    )
}

export default ProductList